import superagent from 'superagent'

export const huntTypesSet = types => ({
  type: 'HUNT_TYPES_SET',
  payload: types
})

export const huntTypesFetchRequest = () => (dispatch, getState, token) => {
  return new Promise(resolve => {
    superagent
      .get(`${__API_URI__}/huntType/get`)
      .set('Authorization', `Bearer ${token}`)
      .set('Content-Type', 'application/json')
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (err) {
          return
        }
        resolve(res.body)
        dispatch(huntTypesSet(res.body))
      })
  })
}
